import { createSelector } from "@reduxjs/toolkit";
import { SelectOption } from "../../types";
import type { ADUsers, State } from "../../types";
import { Selector } from "../application/selectors";

export const usersAdSelector = (state: State) => state.users.adUsers;
export const usersAdAllSelector = (state: State) => state.users.allAdUsers;
export const isLoadingUsersAd = (state: State) => state.users.isLoadingUsers;
export const usersAdOptionsSelector = (): Selector<SelectOption[]> =>
  createSelector(
    usersAdSelector,
    (users: ADUsers[]) =>
      users?.map(({ user_id, mail, name }) => ({
        id: user_id,
        label: mail ? `${name} (${mail})` : `${name}`,
      })) || [],
  );
export const usersAdAllOptionsSelector = (): Selector<SelectOption[]> =>
  createSelector(
    usersAdAllSelector,
    (users) =>
      users?.map(({ user_id, mail, name }) => ({
        id: user_id,
        label: mail ? `${name} (${mail})` : `${name}`,
      })) || [],
  );
